import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { ThemeProvider, DEFAULT_THEME } from '@zendeskgarden/react-theming';
import router from './routes/mainrouter';
import DevelopmentTools from './components/common/DevelopmentTools';
import ErrorBoundary from './components/common/ErrorBoundary';
import './utils/debugAuth'; // Include debug utility

function App() {
  return (
    <ThemeProvider theme={DEFAULT_THEME}>
      <ErrorBoundary>
        <RouterProvider router={router} />
        <DevelopmentTools />
      </ErrorBoundary>
    </ThemeProvider>
  );
}

export default App;
